import {GPItem} from "./gp-item.js";
import {lightDirection, preferredNames} from "./gp.js";
import { get } from 'svelte/store';

'use strict';

export class GPPlant extends GPItem {
    constructor(id, typeId, x, y, scale) {
        super();
        this.id = id;
        this.typeId = typeId;
        this.x = x;
        this.y = y;
        this.scale = scale;
        this.horizontalFlip = 1;
        this.zindex = 0;
        this.relativeBaseOffset = 0;
        this.actualBaseOffset = 0;
        this.imageWidth = null;
        this.imageHeight = null;
        this.data = GP.plantTypesById[typeId];
        this.originItemInstance = null;
        this.fixedObject = false;

        this.supportsFlip = false;
        this.supportsInfo = true;
        this.supportsAdjust = false;
        this.supportsRotate = false;
        this.supportsThumb = true;

        this.randSizeX = 0.96 + 0.08 * Math.random();
        this.randSizeY = 0.96 + 0.08 * Math.random();
        this.randRot = Math.random() * 6 - 3;
        this.randH = Math.random() * 10 - 5;
        this.randS = Math.random() * 0.4 - 0.2;
        this.randV = Math.random() * 0.4 - 0.2;

        lightDirection.subscribe((a) => this.horizontalFlip = a);
    }

    getPathForImage(season) {
        return this.data.staticGetPathForImage(season);
    }

    getPathForThumb(season) {
        return this.data.staticGetPathForThumb(season);
    }

    itemImageScale(projy) {
        var plantSize = this.getHeight();
        var scale = this.scaleAccordingToHorizon(projy);
        if (scale <= 0.1) scale = 0.1;
        scale = scale * plantSize / (this.imageHeight);
        scale = scale * this.scale;
        return scale;
    }

    getName() {
        if (get(preferredNames) === "latin")
            return this.data.latin;
        else
            return this.data.name;
    }

    toJSON() {
       return {
            id: this.id,
            typeId: this.typeId,
            x: this.x,
            y: this.y,
            s: this.scale
        }
    }
}